import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "30px",
	viewBox: "0 0 32 32",
	fill: "#000000",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "chevron_1_",
		children: /* @__PURE__ */ _jsx("path", { d: "M11,15.9c0-0.3,0.1-0.5,0.3-0.8l7.5-9.7c0.4-0.5,1.2-0.6,1.8-0.2c0.5,0.4,0.6,1.2,0.2,1.8l-6.9,8.9l6.9,9 c0.4,0.5,0.3,1.3-0.2,1.8c-0.5,0.4-1.3,0.3-1.8-0.2l-7.5-9.8C11.1,16.4,11,16.1,11,15.9z" })
	})]
});
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;
